module.exports = __webpack_public_path__ + "img/magnifying-glass-minus.0e9bd171.svg";